import { render, staticRenderFns } from "./excess.vue?vue&type=template&id=56dc5a7d&scoped=true&"
import script from "./excess.vue?vue&type=script&lang=js&"
export * from "./excess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dc5a7d",
  null
  
)

export default component.exports